import React, { useEffect, useState } from "react";
import {
  NormalHeading,
  SmallHeading,
} from "../../../../Components/Utils/Heading";
import { BackButton, EditButton } from "../../../../Components/Utils/Buttons";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import Modal from "../../../../Components/Utils/AttachmentView";
import Carousel from "./ImageSlider";

function ViewItems() {
  const { itemsViewId } = useSearchParams();
  const location = useLocation();
  const data = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [filePathList, setFilePathList] = useState([]);

  useEffect(() => {
    if (
      data?.productImage !== null &&
      data?.productImage !== "None" &&
      data?.productImage !== "[]"
    ) {
      setFilePathList(data?.productImage);
    }
  }, [data]);

  function handleImageClick(img) {
    setSelectedImage(img);
    setIsModalOpen(true);
  }

  const detailRows = [
    { label: "Item Code", value: data?.itemCode },
    { label: "HS Code", value: data?.hsCode },
    { label: "Unit", value: data?.unit },
    { label: "Category", value: data?.category },
    { label: "Sub-Category", value: data?.subCategory },
    { label: "Brand", value: data?.brand },
    { label: "Comments", value: data?.comments },
  ];

  return (
    <div className="w-full h-full p-2 sm:px-4">
      {/* Top Header Row */}
      <div className="flex justify-between items-center gap-3 mb-3">
        <Breadcrumb
          items={[
            { name: "Product", link: "/products/items" },
            { name: "View" },
          ]}
        />
        <div className="flex items-center gap-2 self-end sm:self-auto">
          <Link
            to={"/products/items"}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery !== "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link>
          {data?.productId && (
            <Link
              to={`/products/items/edit/${data.productId}`}
              state={{
                data: data,
                from: `/products/items/view/${data.productId}`,
              }}
            >
              <EditButton height="8" />
            </Link>
          )}
        </div>
      </div>

      {/* Main Responsive Content */}
      <div className="w-full mx-auto h-[calc(100vh-140px)] overflow-y-auto pb-4 pr-1">
        <div className="flex flex-col lg:flex-row gap-4 w-full items-start">
          {/* Left Product Details Card */}
          <div className="w-full lg:w-[60%] bg-white rounded-xl shadow-xs border border-slate-200/80 p-2 sm:p-4 flex flex-col gap-2">
            <div className="pb-3 border-b border-gray-100 mb-1">
              <h1 className="text-base sm:text-lg font-bold text-slate-800 break-words">
                {data?.productName || "-"}
              </h1>
            </div>

            <div className="flex flex-col gap-1 w-full">
              {detailRows.map((row, idx) => (
                <div
                  key={idx}
                  className="odd:bg-white even:bg-slate-50/70 w-full flex items-center sm:px-2 py-2.5 rounded-lg text-xs sm:text-sm"
                >
                  <p className="w-1/3 sm:w-2/5 font-semibold text-slate-700 shrink-0">
                    {row.label}
                  </p>
                  <p className="w-2/3 sm:w-3/5 text-slate-600 font-medium break-words pl-2">
                    {row.value || "-"}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Right Product Image Card */}
          <div className="w-full lg:w-[40%] bg-white rounded-xl shadow-xs border border-slate-200/80 p-4 sm:p-5 flex flex-col gap-3">
            <SmallHeading title={"Product Image"} />
            {filePathList && filePathList.length > 0 ? (
              <Carousel images={filePathList} onClick={handleImageClick} />
            ) : (
              <div className="w-full py-10 flex flex-col items-center justify-center text-slate-400 bg-slate-50/50 rounded-lg border border-dashed border-slate-200">
                <svg
                  className="w-10 h-10 mb-2 text-slate-300"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
                <span className="text-xs font-medium">No image available</span>
              </div>
            )}
          </div>
        </div>

        {/* Image Modal */}
        <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <img
            src={selectedImage?.file}
            alt={selectedImage?.file}
            className="max-h-[85vh] mx-auto object-contain rounded-lg"
          />
        </Modal>
      </div>
    </div>
  );
}

export default ViewItems;
